import React, { useState } from "react";
import img from "../assets/images/speakers/sp.jpg";
import panelImg from "../assets/images/speakers/sp1.jpg";
import SpeakerPassModal from "./SpeakerPassModal";

const SpeakerPass = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedPass, setSelectedPass] = useState(null);

  return (
    <section className="container my-5">
      <div className="row align-items-center">

        {/* LEFT CARD — Speaker Pass */}
        <div className="col-lg-6 mb-4">
          <div className="card shadow-lg border-0 h-100" style={{ borderRadius: "12px" }}>
            <div className="row g-0 h-100">
              <div className="col-md-6 p-4 d-flex flex-column">
                <h4 className="fw-bold">Speaker Pass</h4>
                <span className="badge bg-light text-dark mb-3">
                  Speaking Slot + Q&amp;A + Delegate Pass
                </span>

                <ul className="list-unstyled small flex-grow-1">
                  <li>✅ 1 Speaker Pass</li>
                  <li>✅ 30 Minutes Premium Slot</li>
                  <li>✅ Q&amp;A Discussions</li>
                  <li>✅ Certificate of Speaking</li>
                  <li>✅ Promoted on Event Agenda</li>
                  <li>✅ Dedicated Website Blog</li>
                  <li>✅ Full access to all conference activities</li>
                </ul>

                <div className="mt-3">
                  <h5 className="fw-bold">US $599</h5>
                  <button
                    className="btn btn-primary mt-2 px-4"
                    onClick={() => {
                      setSelectedPass({ price: 599, package: "Speaker Pass" });
                      setShowModal(true);
                    }}
                  >
                    Book Now
                  </button>
                </div>
              </div>

              <div className="col-md-6">
                <img
                  src={img}
                  alt="Speaker"
                  className="img-fluid h-100 w-100"
                  style={{ borderRadius: "0 12px 12px 0", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT CARD — Panel Discussion */}
        <div className="col-lg-6 mb-4">
          <div className="card shadow-lg border-0 h-100" style={{ borderRadius: "12px" }}>
            <div className="row g-0 h-100">
              <div className="col-md-6 p-4 d-flex flex-column">
                <h4 className="fw-bold">Panel Discussion</h4>
                <span className="badge bg-light text-dark mb-3">
                  Group Panel Session
                </span>

                <ul className="list-unstyled small">
                  <li>✅ 1 Hour Session for 5 Speakers</li>
                  <li>✅ Live Panel Discussion</li>
                  <li>✅ Certificate of Appreciation</li>
                  <li>✅ Panelists-only Discussion</li>
                </ul>

                {/* 🔥 ADDED CONTENT TO BALANCE HEIGHT */}
                <p className="small text-muted flex-grow-1">
                  Join industry leaders in a professionally moderated panel
                  discussion designed to encourage meaningful dialogue and strategic visibility. 
                </p>

                <div className="mt-3">
                  <h5 className="fw-bold">US $1199</h5>
                  <button
                    className="btn btn-primary mt-2 px-4"
                    onClick={() => {
                      setSelectedPass({ price: 1199, package: "Panel Discussion" });
                      setShowModal(true);
                    }}
                  >
                    Book Now
                  </button>
                </div>
              </div>

              <div className="col-md-6">
                <img
                  src={panelImg}
                  alt="Panel Discussion"
                  className="img-fluid h-100 w-100"
                  style={{ borderRadius: "0 12px 12px 0", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>

      </div>

      {showModal && selectedPass && (
        <SpeakerPassModal
          price={selectedPass.price}
          packageName={selectedPass.package}
          onClose={() => setShowModal(false)}
        />
      )}
    </section>
  );
};

export default SpeakerPass;
